'use client';

import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { BaseModal } from '@/shared/ui/organisms';
import ConsultModalBody from '@/widgets/landing/modals/ui/organisms/ConsultModalBody';

interface ConsultModalProps {
  open: boolean;
  onClose: () => void;
}

const ConsultModal = ({ open, onClose }: ConsultModalProps) => {
  const modalTitle = '상담신청';
  const modalSubTitle = '맞춤 설명을 드리고 병원 매출 성장을 함께 고민합니다.';
  const isDesktop = useIsDesktop();

  return (
    <BaseModal open={open} onClose={onClose} title={modalTitle} subTitle={modalSubTitle} rounded={isDesktop ? '8px' : '16px'}>
      <ConsultModalBody onClose={onClose} />
    </BaseModal>
  );
};

export default ConsultModal;
